module.exports = __webpack_public_path__ + "img/x14.fe99272c.jpg";